<template>
    <div class="aiBasketballContainer" :class="{'aiBasketballContainerDark' : isDark}">
        <TitleBar title="篮球智导" txt="" :type="type"></TitleBar>
        <div class="aiBasketballBox" @click="goModelList">
            <div class="aiBasketballCard">
                <div class="teamData">
                    <div class="teamName">
                        <span class="home">{{aiData.match.home_name_j}}</span>
                        <span class="c">主场</span>
                    </div>
                    <div class="barBox">
                        <span :class="{'home':true, 'isAndroid':isAndroid}" :style="{width: Math.round(aiData.home_win.home_win_single * 1) + '%'}">{{Math.round(aiData.home_win.home_win_single * 1)}}%</span>
                        <span :class="{'guest':true, 'isAndroid':isAndroid}" :style="{width: Math.round(aiData.home_win.home_win_double * 1) + '%'}">{{Math.round(aiData.home_win.home_win_double * 1)}}%</span>
                    </div>
                </div>
                <div class="teamData guest">
                    <div class="teamName">
                        <span class="home">{{aiData.match.away_name_j}}</span>
                        <span class="c">客场</span>
                    </div>
                    <div class="barBox">
                        <span :class="{'home':true, 'isAndroid':isAndroid}" :style="{width: Math.round(aiData.away_win.away_win_single * 1) + '%'}">{{Math.round(aiData.away_win.away_win_single * 1)}}%</span>
                        <span :class="{'guest':true, 'isAndroid':isAndroid}" :style="{width: Math.round(aiData.away_win.away_win_double * 1) + '%'}">{{Math.round(aiData.away_win.away_win_double * 1)}}%</span>
                    </div>
                </div>
                <div class="point">
                  <span><em :class="{'single':true,'isAndroid':isAndroid}"></em>单分</span><span class="double"><em :class="{'double':true,'isAndroid':isAndroid}"></em>双分</span>
                </div>
                <div class="btm">
                    <span class="league">{{aiData.match.league_name_j}}</span>
                    <span class="team"><em class="w">{{aiData.match.home_name_j}}</em> <em>{{aiData.match.match_state === '-1' ? (aiData.match.home_score + ':' + aiData.match.away_score) : 'VS'}}</em> <em class="w">{{aiData.match.away_name_j}}</em></span>
                    <span class="time">{{matchTime}}</span>
                </div>
                <div class="approval">
                    <p class="per">
                      <ChartsPie
                            id="aiPie"
                            :colors = "['#FF5048','#169AFF']"
                            :data="[aiData.win_rate.home_win_rate * 1, 100 - aiData.win_rate.home_win_rate * 1]"
                            type="ai"
                            text=""
                        />
                    </p>
                    <p class="home"><em></em>主胜 {{Math.round(aiData.win_rate.home_win_rate * 1)}}%</p>
                    <p class="guest"><em></em>客胜 {{Math.round(aiData.win_rate.away_win_rate * 1)}}%</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isAndroid } from "../../utils/base";
import TitleBar from '../../components/datamodel/common/titleBar.vue'
import ChartsPie from '../../components/datamodel/common/chartsPie.vue'
export default {
    name: 'aiBasketballCorpus',
    props: ['aiData'],
    components: {
        TitleBar,
        ChartsPie
    },
    computed: {
        matchTime () {
            return this.aiData.match.match_time.substring(2, 16).replace(/-/g, '.');
        },
        isAndroid () {
            return isAndroid()
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "6"
        }
    },
    methods: {
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>

<style lang="less" scoped>
.aiBasketballContainer{
    width: 100%;
    .aiBasketballBox{
        width: 100%;
        padding: 0 14px;
        .aiBasketballCard{
            position: relative;
            width: 100%;
            padding: 10px 10px 0;
            background: #FFFFFF;
            border-radius: 5px;
            .teamData{
                padding-right: 85px;
                &.guest{
                  margin-top: 8px;
                }
                .teamName{
                    position: relative;
                    width: 100%;
                    font-size: 10px;
                    font-weight: bold;
                    color: #333333;
                    overflow: hidden;
                    text-align: center;
                    .home{
                        float: left;
                        font-size: 12px;
                        font-weight: bold;
                    }
                    .c{
                        position: absolute;
                        left: 62%;
                        top: 3px;
                    }
                }
                .barBox{
                    display: flex;
                    width: 100%;
                    height: 12px;
                    border-radius: 7.5px;
                    align-items: center;
                    span{
                        position: relative;
                        display: inline-block;
                        width: auto;
                        height: 12px;
                        line-height: 12px;
                        padding: 0 5px;
                        font-size: 9px;
                        color: #FFFFFF;
                        vertical-align: middle;
                        &.home{
                            border-radius: 7.5px 0 0 7.5px;
                            background: #FF5048;
                            text-align: left;
                        }
                        &.guest{
                            border-radius: 0 7.5px 7.5px 0;
                            background: #169AFF;
                            text-align: right;
                        }
                        &.isAndroid{
                            // padding-top: 2.5px;
                        }
                    }
                }
            }
            .point{
                width: 100%;
                margin-top: 15px;
                text-align: left;
                span{
                    position: relative;
                    padding-left: 4px;
                    font-size: 10px;
                    color: #666666;
                    vertical-align: middle;
                    &.double{
                        margin-left: 10px;
                    }
                    em{
                        position: absolute;
                        left: 0;
                        top: 3.8px;
                        width: 2.5px;
                        height: 9px;
                        vertical-align: middle;
                        &.single{
                            background: #FF5048;
                        }
                        &.double{
                            background: #169AFF;
                        }
                        &.isAndroid{
                            top: 0;
                        }
                    }
                }
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                text-align: center;
                .league{
                    float: left;
                    height: 30px;
                    color: #BE2FD1;
                    width: 65px;
                    max-width: 65px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                }
                .team{
                    color: #333333;
                    em{
                        display: inline-block;
                        vertical-align: middle;
                        color: #FF5048;
                        &.w{
                            color: #333333;
                            max-width: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
            .approval{
                position: absolute;
                right: 8px;
                top: 10px;
                .per{
                    font-size: 20px;
                    font-weight: bold;
                    color: #171717;
                }
                .home, .guest{
                    font-size: 10px;
                    color: #666666;
                    text-align: center;
                    em{
                        display: inline-block;
                        width: 2.5px;
                        height: 9px;
                        margin-right: 2px;
                        vertical-align: middle;
                    }
                }
                .home{
                    margin: 5px 0 4px;
                    em{
                      background: #FF5048;
                    }
                }
                .guest{
                    em{
                      background: #169AFF;
                    }
                }
            }
        }
    }
}
.aiBasketballContainerDark {
    background-color: #191919;
    .aiBasketballBox {
        .aiBasketballCard {
            background: #232323;
            .teamData{
                .teamName {
                    color: #d3d3d3;
                }
            }
            .point {
                span {
                    color: #a6a6a6;
                }
            }
            .btm {
                border-color: #2f2f2f;
                .team {
                    color: #d3d3d3;
                    em {
                        &.w {
                            color: #d3d3d3;
                        }
                    }
                }
                .time {
                    color: #a6a6a6;
                }
            }
            .approval {
                .per {
                    color: #FFFFFF !important;
                }
                .home, .guest{
                    color: #a6a6a6;
                }
            }
        }
    }
}
</style>
